import { render, staticRenderFns } from "./URLIframe.vue?vue&type=template&id=84cfe3e2&scoped=true"
import script from "./URLIframe.vue?vue&type=script&lang=js"
export * from "./URLIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cfe3e2",
  null
  
)

export default component.exports